import { useCallback, useMemo } from 'react'

import { AppId, InnosErrorBoundary } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useMountApp } from 'modules/app-registry/hooks/useMountApp'
import { useWindowManager } from 'modules/desktop/pages/MainPage/components/WindowManager/hooks/useWindowManager'
import { useUserContext } from 'shared/hooks'
import { useCommonStore } from 'shared/stores/commonStore'
import { getIsInsideWindow } from 'shared/utils'

const ClusterMeetCallModalContent = () => {
  const { user } = useUserContext()
  const { openAppWindow } = useWindowManager()
  const { apps } = useAvailableApps()
  const isDetached = useCommonStore(state => state.isDetached)

  const onAcceptCallUrl = useCallback(
    (url: string) => {
      const roomId = url.split('join/')[1]
      const roomPath = `${apps[AppId.CLUSTER_MEET].path}/join/${roomId}`

      if (isDetached) {
        window.location.assign(
          `${process.env.REACT_APP_CONTAINER_DOMAIN}${roomPath}`
        )
      } else {
        openAppWindow(AppId.CLUSTER_MEET, roomPath)
      }
    },
    [openAppWindow, apps, isDetached]
  )

  const appProps = useMemo(
    () => ({
      user,
      onAcceptCallUrl
    }),
    [user, onAcceptCallUrl]
  )

  const { ref, isLoaded, isError } = useMountApp(
    {
      url: process.env.REACT_APP_CLUSTER_MEET_APP_DEV_PATH,
      scope: 'cluster_meet',
      envKey: apps[AppId.CLUSTER_MEET].runtimeEnvKey,
      entryPath: './ClusterMeetCallWidget'
    },
    appProps
  )

  if (isError || !isLoaded || !user) return null
  return <div ref={ref} />
}

export const ClusterMeetCallModal = () => {
  if (getIsInsideWindow()) return null
  return (
    <InnosErrorBoundary debugName='ClusterMeetCallModal'>
      <ClusterMeetCallModalContent />
    </InnosErrorBoundary>
  )
}
